var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container"},[_c('span',[_vm._v("Copyright "+_vm._s(_vm.currentDateTime())+"  ©COLEXO")]),_c('span',{staticClass:"href",on:{"click":_vm.mentionOn}},[_vm._v("Mentions légales")])])])}
var staticRenderFns = []

export { render, staticRenderFns }